import { render, staticRenderFns } from "./recommendationCell.vue?vue&type=template&id=485ff968&scoped=true&"
import script from "./recommendationCell.vue?vue&type=script&lang=js&"
export * from "./recommendationCell.vue?vue&type=script&lang=js&"
import style0 from "./recommendationCell.vue?vue&type=style&index=0&id=485ff968&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485ff968",
  null
  
)

export default component.exports